export function flagsToEnumArray<T extends Record<string, boolean>, E extends string>(
  flags: T,
  labels: { [K in keyof T]?: E }
): E[] {
  return Object.entries(flags)
    .filter(([key, value]) => value && key in labels) //return only existings labels
    .map(([key]) => labels[key as keyof T]!); //return string only if value is true
}
